<template>
  <div id="site-header" ref="header" class="header">
    <div class="u-width-wrapper">
      <NuxtLink to="/"> <Logo /> </NuxtLink>
      <div v-if="headerText" class="header__text">
        <p class="h1">{{ headerText }}</p>
      </div>
      <button v-if="isUserLoggedIn && !routeIsHome" class="mobile__search">
        <fa-icon :icon="['fas', 'search']" />
      </button>
      <FieldsSearch
        v-if="isUserLoggedIn && !isRouteExcluded"
        placeholder="Search Files, Tags, Topics and Content Types"
      />
      <Navigation
        v-if="
          isUserLoggedIn &&
          !routeIsLogin &&
          !routeIsPasswordReset &&
          !routeIsPublicDownload
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  const props = defineProps<{
    headerText?: string;
  }>();

  const isUserLoggedIn = computed(() => useUserStore().isUserLoggedIn);

  const route = useRoute();
  const routeIsHome = computed(() => route.name === "index");
  const routeIsLogin = computed(() => route.name === "login");
  const routeIsPasswordReset = computed(
    () => route.name === "reset-password-code"
  );
  const routeIsPublicDownload = computed(
    () => route.name === "public-download-file"
  );

  const excludedRoutes = [
    "index",
    "login",
    "reset-password-code",
    "public-download-file",
    "cookies",
    "abort",
    "success",
    "welcome"
  ];
  const isRouteExcluded = computed(() =>
    excludedRoutes.includes(String(route.name))
  );
</script>

<style lang="scss" scoped>
  .header {
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    z-index: 99;
    background: $white;
    width: 100%;
    min-height: 70px;
    border-top: 3px solid $white;
    border-bottom: 1px solid $pfgreen;

    .u-width-wrapper {
      display: flex;
      position: relative;
      align-items: center;
      justify-content: flex-end;
      background: $white;
      padding: 15px 10px;

      @include respond-to-max("lg") {
        flex-direction: row;
      }

      @include respond-to-max("sm") {
        padding: 0 10px;
        justify-content: space-between;
      }
    }

    .logo {
      width: 110px;
      position: absolute;
      top: 0;
      left: 40px;
      padding: 10px 10px 10px 0;

      @include respond-to-max("lg") {
        left: 20px;
        z-index: 2;
      }

      @include respond-to-max("sm") {
        position: relative;
        left: 0;
      }
    }
  }

  .header__text {
    p {
      margin-bottom: 0;
    }
  }

  .mobile__search {
    display: none;
    font-size: 2rem;
    margin-right: 20px;

    &:active {
      color: $pforange;
    }

    @include respond-to-max("xl") {
      display: inline;
    }

    @include respond-to-max("sm") {
      margin-right: 0;
      margin-left: 20px;
    }
  }

  .search {
    width: 30%;

    @include respond-to-max("xxl") {
      width: 25%;
    }

    @include respond-to-max("xl") {
      position: absolute;
      right: 0;
      width: 80%;
      padding-right: 0;
      z-index: 2;
      opacity: 0%;
      pointer-events: none;
      transition: 0.3s all ease-in-out;
    }

    &.active {
      opacity: 100%;
      pointer-events: all;
    }
  }
</style>
